module.exports = __webpack_public_path__ + "img/7297aca22562b2335cb10ba1b72b905c.png";